var _defs, _g, _g2, _mask, _g3, _mask2, _use, _path, _rect, _path2, _g4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _mask3, _use2, _path0, _path1, _path10, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPillarCultureIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "333px",
    height: "222px",
    viewBox: "0 0 333 222",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.4122371%",
    cy: "0%",
    fx: "49.4122371%",
    fy: "0%",
    r: "79.9715909%",
    gradientTransform: "translate(0.494122,0.000000),scale(0.396396,1.000000),rotate(90.000000),scale(1.000000,1.707647),translate(-0.494122,-0.000000)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "39.9297142%",
    y1: "0%",
    x2: "61.7643779%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756",
    stopOpacity: 0.25,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.60727641,0 L35.8905336,0 C40.0919164,-7.7178149e-16 43.49781,3.40589366 43.49781,7.60727641 L43.49781,65.3927236 C43.49781,69.5941063 40.0919164,73 35.8905336,73 L7.60727641,73 C3.40589366,73 3.17905625e-15,69.5941063 0,65.3927236 L0,7.60727641 C-5.14520993e-16,3.40589366 3.40589366,7.7178149e-16 7.60727641,0 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.3%",
    y: "-1.4%",
    width: "104.6%",
    height: "102.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.7 0",
    type: "matrix",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-5",
    cx: 21.748905,
    cy: 3.41920375,
    rx: 1.35930656,
    ry: 1.3676815
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-73.6%",
    y: "-73.1%",
    width: "247.1%",
    height: "246.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "97.2154111%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFAFAF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.4468082,2.88748803 L11.2317741,2.88748803 C12.766821,2.88748803 14.1996929,3.65685148 15.0476995,4.93640358 C15.8957061,6.21595568 17.3285779,6.98531913 18.8636248,6.98531913 L24.443699,6.98531913 C25.9787458,6.98531913 27.4116177,6.21595568 28.2596243,4.93640358 C29.1076309,3.65685148 30.5405028,2.88748803 32.0755496,2.88748803 L36.8605156,2.88748803 C38.961207,2.88748803 40.6641538,4.59043486 40.6641538,6.69112623 L40.6641538,66.5273201 C40.6641538,68.6280115 38.961207,70.3309583 36.8605156,70.3309583 L6.4468082,70.3309583 C4.34611683,70.3309583 2.64317,68.6280115 2.64317,66.5273201 L2.64317,6.69112623 C2.64317,4.59043486 4.34611683,2.88748803 6.4468082,2.88748803 Z",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.3%",
    y: "-0.7%",
    width: "102.6%",
    height: "101.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.8036382,0 L14.8783051,0 C16.3610304,-2.93690748e-15 17.7855171,0.577218269 18.8500003,1.60937618 L19.7566101,2.48845493 C20.8210933,3.52061284 22.24558,4.09783111 23.7283053,4.09783111 L35.4380385,4.09783111 C36.9207638,4.09783111 38.3452505,3.52061284 39.4097336,2.48845493 L40.3163435,1.60937618 C41.3808266,0.577218269 42.8053133,-8.57872594e-15 44.2880386,0 L55.3627056,0 C57.4633969,-8.29979955e-16 59.1663438,1.70294683 59.1663438,3.8036382 L59.1663438,63.6398321 C59.1663438,65.7405235 57.4633969,67.4434703 55.3627056,67.4434703 L3.8036382,67.4434703 C1.70294683,67.4434703 2.92179576e-15,65.7405235 0,63.6398321 L0,3.8036382 C-2.57260497e-16,1.70294683 1.70294683,-5.02287675e-16 3.8036382,0 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.4789497%",
    y1: "60.0049909%",
    x2: "43.893748%",
    y2: "5.24524905%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD0CE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5ACA9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.5967895,40.1513863 L55.4476964,18.2365925 L64.2194593,26.3721091 C64.2194593,26.3721091 56.2023748,40.3703943 54.8192118,40.3703943 C53.4360488,40.3703943 53.5967895,40.1513863 53.5967895,40.1513863 M5.71209952,10.1382156 C5.76466038,10.2307255 5.81256244,10.3248112 5.8563552,10.4204727 C6.15666885,11.0738605 6.27414238,11.7931155 6.51159802,12.4705762 C6.85367367,13.4250334 7.23588671,14.3685329 7.58825951,15.3182871 C8.28676949,17.1650433 8.9914912,19.017545 9.83117487,20.8041553 C11.2040168,23.7282547 13.1604994,27.3872456 16.1076108,28.9182656 C20.3224664,31.1079098 26.1512511,27.7855523 28.0072946,23.6926907 C27.8465539,24.0496879 27.997523,24.8661802 27.991813,25.2540383 C27.9774305,26.6120628 27.9521774,27.9643175 27.9171288,29.3218087 C27.8362807,32.3629274 27.891374,35.4814528 27.2330492,38.4672012 C26.900769,39.972621 26.2826054,41.2992755 25.6835072,42.7074823 C25.1853735,43.8814566 24.8036383,45.1778079 25.0854362,46.4229101 C25.300219,47.362749 25.9786842,48.045931 26.1610226,48.9340118 C26.1878287,49.0636615 26.203788,49.1974809 26.20687,49.3370458 C26.2115288,49.82682 26.20687,50.3171275 26.20687,50.8016652 C26.2115288,52.4910867 26.2115288,54.1799748 26.2171672,55.869372 C26.2223516,61.0442556 26.2316214,66.2191149 26.2470552,71.388762 C26.2723083,80.774084 26.388205,90.368523 26.7596192,99.8301608 C26.9512752,104.667853 27.2077961,109.500891 27.5544828,114.328645 C27.7260223,116.74777 27.9217876,119.161683 28.1427822,121.575547 C28.2741365,123.039682 27.9521774,127.179041 29.058703,128.215074 C29.3136709,128.451852 29.4465066,128.190735 29.5989809,128.269135 L29.7107921,128.493234 C29.8879939,128.584193 29.9540056,128.769697 29.9709923,128.771225 L29.9735965,128.771225 C29.9735965,128.771225 29.9493707,129.298139 29.5836188,129.899235 C29.2003545,130.529107 28.6046966,131.44914 27.1046334,131.720415 C24.1667918,132.250966 20.2932235,133.280211 19.4173684,135.507965 C22.998101,135.507965 39.2481279,135.966902 39.7009159,135.507965 C40.0352507,135.172374 39.2383325,131.731882 38.7891282,129.899235 C38.6351249,129.270938 38.5217607,128.831347 38.5094328,128.771225 C38.5088833,128.76914 38.5083816,128.767588 38.5083816,128.765988 C38.5068286,128.758716 38.5099106,128.750328 38.5166241,128.740412 C38.6273841,128.583587 39.7555314,128.129352 39.5752237,127.409055 C39.3887521,126.643278 38.317275,95.7676026 38.9060523,85.9845073 C39.4696242,76.5077178 40.9836159,68.0308648 41.0789183,67.5102297 C40.913041,68.5922517 42.5475644,71.4195987 42.9498939,72.5319482 C43.6587249,74.4916025 44.347989,76.4564446 45.0171604,78.4318081 C46.3395201,82.361056 47.5619424,86.3263528 48.6128252,90.3376621 C49.6693702,94.3589109 50.5492151,98.4214207 51.198294,102.529434 C51.7464082,105.989805 51.7762963,109.776845 52.9631683,113.093482 C53.969231,115.900465 57.0523318,127.893593 57.7415719,128.439319 C57.8157783,128.497331 57.8312121,128.60029 57.799795,128.740412 C57.7977404,128.750328 57.7951601,128.760776 57.7925798,128.771225 C57.7215032,129.038864 57.4937952,129.430382 57.1821332,129.899235 C56.0983043,131.52805 54.0047813,134.082013 54.0047813,135.548741 L70.6019966,135.548741 C70.6019966,135.548741 70.6019966,134.211638 69.7216499,132.710921 C69.222465,131.859932 68.4405028,130.723558 67.8568383,129.899235 C67.4112416,129.269896 67.0815655,128.82194 67.0815655,128.82194 C67.0815655,128.82194 67.1181192,128.805746 67.1773935,128.771225 C67.1928273,128.762352 67.2098379,128.751879 67.227852,128.740412 C67.4349418,128.609187 67.8063559,128.308627 67.9614105,127.771288 C68.182405,127.005512 64.470318,110.648732 63.5502879,105.377193 C62.6245955,100.105606 58.0182093,71.9501732 58.0182093,68.9748734 C58.0182093,66.6399187 55.8417595,54.6708156 54.9011112,49.6004664 C54.8568167,49.362646 54.8156042,49.139444 54.7769481,48.9340118 C54.66313,48.3229759 54.5760462,47.8614202 54.5255877,47.5932723 C54.3823594,47.4474286 54.2669883,47.2618753 54.2247246,47.0752555 C54.0995581,46.5164867 54.3931821,45.7240189 55.0350458,45.6273392 C55.2936453,45.588648 55.5486372,45.5515567 55.800547,45.4814955 C55.853084,45.4668772 55.9066722,45.4511679 55.9602365,45.437592 C56.2950731,45.1286923 56.9220047,45.1009587 57.2856781,45.3382699 C57.4330158,45.4344647 57.5587079,45.5557265 57.6607237,45.698952 C62.0718225,41.7634252 75.3134806,28.8732955 74.5902193,25.3821122 C74.3635625,24.2844052 73.7598054,23.2384563 73.2369204,22.2687989 C72.3766663,20.6865784 71.4262226,19.1555342 70.445413,17.6501386 C68.1870399,14.179804 65.7633152,10.8015428 63.1433234,7.60146517 C62.1223287,6.35115074 61.0760808,5.11649706 59.914438,3.99891111 C55.7649968,0.00801410698 49.151144,-0.104374797 43.8050353,0.0331052449 C42.5068775,0.0686449629 41.1845179,0.0639418898 39.8869096,0.186779374 C38.056621,0.349859649 36.225281,0.640504724 34.4248804,1.02312639 C33.0669705,1.30904415 31.7440852,1.68172634 30.4413165,2.1715005 C28.3241171,2.97284115 27.1366956,5.19802507 25.8998668,7.00924159 C23.3648564,10.7199906 21.187881,14.6905238 18.8939816,18.5585833 C18.8888211,18.5533954 10.5703717,10.2604955 10.1526084,8.51987355 C10.1232221,8.39652697 10.0830609,8.26324091 10.0341315,8.12314266 C9.39021313,6.28632591 7.17147576,3.18401883 6.00369285,2.67177173 C4.74622199,2.12030004 5.3551157,4.00887484 5.81769907,4.73387539 C6.27516971,5.4583426 6.12936109,5.47873066 4.78638327,5.09610899 C3.44858986,4.71348732 2.58883749,4.9680351 1.87434424,4.20279176 C1.16551322,3.43701508 0.556595625,2.24834969 0.154791721,2.48306698 C-0.242878988,2.71252362 0.154791721,5.29002591 1.01454409,6.60676519 C1.87434424,7.92345599 5.33452139,9.47435498 5.71209952,10.1382156 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.9042622%",
    y1: "75.8500731%",
    x2: "46.0810374%",
    y2: "24.1499269%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.7096706%",
    y1: "100%",
    x2: "49.7096706%",
    y2: "15.5932583%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.5218155%",
    y1: "60.0049909%",
    x2: "36.7312544%",
    y2: "5.24524905%",
    id: "linearGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD0CE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5ACA9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.2917348%",
    y1: "96.5490149%",
    x2: "35.8709874%",
    y2: "56.0054351%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9",
    offset: "0.00263935811%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "32.0839234%",
    y1: "77.7235798%",
    x2: "17.1603836%",
    y2: "53.5767064%",
    id: "linearGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9",
    offset: "0.00263935811%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.6608459%",
    y1: "53.9663089%",
    x2: "29.8016818%",
    y2: "32.2577381%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD0CE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5ACA9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "69.6369682%",
    y1: "38.4660051%",
    x2: "28.1017411%",
    y2: "-2.37278294%",
    id: "linearGradient-21"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD0CE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5ACA9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.359345727,4.7176996 C0.177283638,5.2266134 0.0565149888,5.75774293 0.00457585686,6.29629377 C-0.0710241694,7.08008511 0.806749553,7.3980207 1.40894204,7.55977148 C2.31365425,7.80277114 3.2759756,7.8949833 4.19674086,7.68631925 C4.99764658,7.50481043 5.73048835,7.10724035 6.47876114,6.7672336 C7.15641011,6.45934569 7.86104542,6.19779277 8.59273884,6.05592049 C9.2160802,5.93505919 10.1124668,5.78769321 10.6811656,6.14027763 C11.1040712,6.40248113 11.2621375,6.92435812 11.3565897,7.42385071 C11.5246562,8.31267283 11.6164767,9.2127233 11.6726026,10.1157134 C11.7200679,10.8798672 11.8193288,11.6647669 11.6857847,12.4267762 C11.6321709,12.7327365 12.4234352,12.538144 13.2878833,12.2412917 C14.5953809,11.7923266 15.4677478,10.5454023 15.4521732,9.15419617 C15.4329862,7.43866923 15.3137247,5.62073787 14.7154079,3.99843509 C13.7484214,1.37659294 10.4682415,0.166245045 7.9092524,0.0146865119 C4.64936013,-0.178363881 1.49638448,1.53940391 0.359345727,4.7176996 Z",
    id: "path-22"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-22.7%",
    y: "-40.0%",
    width: "145.5%",
    height: "180.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-24"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.15561925,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.6608459%",
    y1: "58.4276431%",
    x2: "29.8016818%",
    y2: "12.3011083%",
    id: "linearGradient-25"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD0CE",
    stopOpacity: 0.98989292,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD0CE",
    stopOpacity: 0.98989292,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.6403821%",
    y1: "0%",
    x2: "46.3036192%",
    y2: "30.6167542%",
    id: "linearGradient-26"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50.3201244%",
    fx: "50%",
    fy: "50.3201244%",
    r: "42.199855%",
    gradientTransform: "translate(0.500000,0.503201),scale(0.076923,1.000000),rotate(90.000000),scale(1.000000,16.542268),translate(-0.500000,-0.503201)",
    id: "radialGradient-27"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.12538243,
    offset: "0.279771959%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50.3201244%",
    fx: "50%",
    fy: "50.3201244%",
    r: "42.199855%",
    gradientTransform: "translate(0.500000,0.503201),scale(0.072626,1.000000),rotate(90.000000),scale(1.000000,16.542268),translate(-0.500000,-0.503201)",
    id: "radialGradient-28"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.12538243,
    offset: "0.279771959%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.4335022%",
    y1: "3.99331665%",
    x2: "50%",
    y2: "90.421814%",
    id: "linearGradient-29"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EEDC7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57C4D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-30",
    cx: 71.1539059,
    cy: 71.1539059,
    r: 71.1539059
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.8%",
    y: "-2.8%",
    width: "105.6%",
    height: "105.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-32"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -4,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "17.0044556%",
    x2: "50%",
    y2: "74.1980896%",
    id: "linearGradient-33"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.26,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-34",
    points: "0 -1.01115782e-14 23.9909625 -1.01115782e-14 23.9909625 44.7946232 0 44.7946232"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-36",
    points: "0 0 24.0353625 0 24.0353625 44.7524048 0 44.7524048"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-38"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.34999967,0 L68.6500003,0 C72.7092931,-7.45679977e-16 76,3.29070694 76,7.34999967 L76,43.1659683 C76,46.9402998 72.9402998,50 69.1659683,50 L6.83403165,50 C3.05970019,50 4.70268047e-15,46.9402998 0,43.1659683 L0,7.34999967 C-4.97119984e-16,3.29070694 3.29070694,7.45679977e-16 7.34999967,0 Z",
    id: "path-39"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.6%",
    y: "-4.0%",
    width: "105.3%",
    height: "108.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-40"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -2,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "83.7378561%",
    x2: "0%",
    y2: "83.7378561%",
    id: "linearGradient-41"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-42",
    x: 0,
    y: 5.05300208,
    width: 12.8322097,
    height: 2.59255342,
    rx: 0.222041942
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-7.8%",
    y: "-38.6%",
    width: "115.6%",
    height: "177.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-43"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0852272727 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-44",
    x: 0,
    y: 10.1060042,
    width: 20.5020363,
    height: 2.59255342,
    rx: 0.222041942
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.9%",
    y: "-38.6%",
    width: "109.8%",
    height: "177.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-45"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0852272727 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-46",
    x: 0,
    y: 0,
    width: 17.6995997,
    height: 2.59255342,
    rx: 0.222041942
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.6%",
    y: "-38.6%",
    width: "111.3%",
    height: "177.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-47"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0852272727 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-48",
    x: 0,
    y: 15.1590062,
    width: 8.99729649,
    height: 2.59255342,
    rx: 0.222041942
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-11.1%",
    y: "-38.6%",
    width: "122.2%",
    height: "177.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-49"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0852272727 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.6745805,3.56682524 C16.6071464,3.56682524 18.9844607,6.22836199 18.9844607,9.51153396 C18.9844607,11.9849259 17.635233,14.1055133 15.7158204,15.001114 C20.9135352,15.8362531 24.8843277,20.3426753 24.8843277,25.7765257 L24.8843277,30.7586428 L3.05481999,30.7586428 L3.05481999,25.7765257 C3.05481999,20.4892983 6.81421366,16.0801245 11.8057666,15.0762384 C9.79534155,14.2312855 8.36470024,12.0584563 8.36470024,9.51153396 C8.36470024,6.22836199 10.7420146,3.56682524 13.6745805,3.56682524 Z",
    id: "path-50"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.6%",
    y: "-3.7%",
    width: "109.2%",
    height: "107.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-51"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0852272727 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.34999967,0 L68.6500003,0 C72.7092931,-7.45679977e-16 76,3.29070694 76,7.34999967 L76,43.1659683 C76,46.9402998 72.9402998,50 69.1659683,50 L6.83403165,50 C3.05970019,50 4.70268047e-15,46.9402998 0,43.1659683 L0,7.34999967 C-4.97119984e-16,3.29070694 3.29070694,7.45679977e-16 7.34999967,0 Z",
    id: "path-52"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50.3201244%",
    fx: "50%",
    fy: "50.3201244%",
    r: "42.199855%",
    gradientTransform: "translate(0.500000,0.503201),scale(0.074074,1.000000),rotate(90.000000),scale(1.000000,16.542268),translate(-0.500000,-0.503201)",
    id: "radialGradient-54"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.12538243,
    offset: "0.279771959%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "events-icon_culture",
    transform: "translate(0.000000, -31.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 31.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphic-healthy-bites-hero",
    fill: "url(#radialGradient-1)",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.5,132 C258.455411,132 333,72.901587 333,0 C312.416209,0 24.2431319,0 0,0 C0,72.901587 74.5445892,132 166.5,132 Z",
    id: "sky",
    transform: "translate(166.500000, 66.000000) scale(1, -1) translate(-166.500000, -66.000000) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(30.000000, 39.783700)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 53.216300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-101",
    transform: "translate(7.000000, 0.000000)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Phone",
    transform: "translate(18.502190, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#575756",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#linearGradient-2)",
    strokeWidth: 1.66409171,
    d: "M35.8905336,0.832045857 C37.7614619,0.832045857 39.4552695,1.59038937 40.6813451,2.81646494 C41.9074207,4.04254052 42.6657642,5.73634815 42.6657642,7.60727641 L42.6657642,7.60727641 L42.6657642,65.3927236 C42.6657642,67.2636518 41.9074207,68.9574595 40.6813451,70.1835351 C39.4552695,71.4096106 37.7614619,72.1679541 35.8905336,72.1679541 L35.8905336,72.1679541 L7.60727641,72.1679541 C5.73634815,72.1679541 4.04254052,71.4096106 2.81646494,70.1835351 C1.59038937,68.9574595 0.832045857,67.2636518 0.832045857,65.3927236 L0.832045857,65.3927236 L0.832045857,7.60727641 C0.832045857,5.73634815 1.59038937,4.04254052 2.81646494,2.81646494 C4.04254052,1.59038937 5.73634815,0.832045857 7.60727641,0.832045857 L7.60727641,0.832045857 Z",
    strokeLinejoin: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    opacity: 0.65,
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-13"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-7)",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-9)",
    xlinkHref: "#path-8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Man",
    transform: "translate(0.000000, 2.887488)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-10"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-3",
    mask: "url(#mask-11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.829887, 28.668631)"
  }, _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "none",
    fill: "url(#linearGradient-12)",
    fillRule: "evenodd",
    xlinkHref: "#path-13"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.6092359,40.0694405 L56.0139822,20.5279794 L64.22563,26.3182006 C64.22563,26.3182006 56.2130963,40.2882211 54.8306872,40.2882211 C53.448278,40.2882211 53.6092359,40.0694405 53.6092359,40.0694405 Z M70.651344,17.4080029 C68.3943037,13.9447233 65.9718164,10.5731608 63.3534147,7.37980656 C62.3328445,6.1320098 61.2872985,4.89947904 60.1262811,3.78435867 C57.4419538,1.20590289 53.5214624,0.249708702 49.7843303,-0.0667404531 C48.8628515,-0.144594687 47.9400834,0.0225337936 47.0313552,0.00734036317 L47.0199896,-0.198908782 C45.924874,-0.216884448 44.8502691,-0.199368455 43.82287,-0.173118659 C42.525966,-0.137675386 41.2040146,0.0635173463 39.9070867,0.186032524 C39.8770727,0.188790567 39.8475363,0.19154861 39.8175224,0.194330847 C39.7575183,0.199846933 39.6975143,0.205387212 39.6375102,0.21184684 C39.7929876,0.23664886 39.6012994,0.256140644 39.0624456,0.270322192 C38.5833206,0.322845978 38.1046731,0.384103566 37.6268614,0.452715937 C37.0995517,0.528731475 36.5731254,0.407691346 36.0485377,0.501658359 C35.5130619,0.597439873 34.979353,0.702463251 34.4484139,0.814889797 C33.0910045,1.09998436 31.7690769,1.47215082 30.4671348,1.96083251 C28.3510431,2.76044727 26.9612516,5.18723562 25.7247815,6.99508448 C23.1913596,10.6979025 21.2190383,14.4541629 18.9265638,18.3144555 C18.9215734,18.3093991 10.6076346,10.2395593 10.1903044,8.50264536 C10.1607919,8.37921083 10.1207733,8.24653444 10.0716812,8.10652747 L5.69298153,10.398921 C5.99302563,11.0511498 6.11074148,11.7692329 6.34803563,12.4449293 C6.68988916,13.3974461 7.07173742,14.3393662 7.42402539,15.2868265 C8.12229769,17.1301671 8.82644384,18.9790237 9.66559312,20.7615179 C11.0375439,23.6798662 13.1964999,27.9502869 16.1417601,29.4780976 C20.353982,31.6631935 25.9761633,28.3477838 27.8313222,24.2631704 C27.670412,24.6196837 27.8213175,24.8157445 27.8158735,25.2026447 C27.8013321,26.557739 27.7758787,27.9072931 27.7408505,29.2619035 C27.6604074,32.2972509 27.3087795,35.4090977 26.6505258,38.3887036 C26.3186769,39.8911839 25.7008955,41.2154316 25.1022161,42.620703 C24.6044189,43.7920245 24.2225945,45.0858371 24.5044201,46.3285532 C24.7503579,47.4031255 25.6049798,48.1414827 25.6249652,49.2367645 L53.2864366,49.4997947 L54.9125152,49.4997947 C54.7197764,48.4633512 54.5788755,47.7155344 54.5189431,47.398553 C54.461088,47.2709088 54.4345602,47.1346276 54.4399565,46.9894916 C54.4537577,46.885436 54.4675588,46.781332 54.48136,46.6772763 C54.4992442,46.6126317 54.5223098,46.5510596 54.5495779,46.4919794 C54.6541134,46.1055872 54.9288713,45.7700011 55.3421423,45.6803647 C55.5223932,45.6412682 55.7054616,45.6135426 55.8842082,45.5677204 C55.905889,45.5623011 55.9271877,45.555527 55.9487012,45.549406 C56.0061982,45.5063903 56.1096353,45.4647051 56.156268,45.4302779 C56.3851334,45.2612631 56.7881132,45.2389568 57.0494758,45.3118998 C57.2474915,45.3671575 57.864183,45.702333 58.0141335,45.8679124 C62.357753,42.0087327 75.520172,28.831431 74.7935333,25.3301921 C74.5671272,24.2349103 73.9639111,23.1912087 73.4411142,22.2234743 C72.5814781,20.644543 71.6318478,18.9104589 70.651344,17.4080029 Z",
    id: "Fill-3",
    stroke: "none",
    fill: "url(#linearGradient-15)",
    fillRule: "evenodd",
    mask: "url(#mask-14)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "none",
    fill: "url(#linearGradient-16)",
    fillRule: "evenodd",
    opacity: 0.296851749,
    mask: "url(#mask-14)",
    x: 24.601813,
    y: 35.8873512,
    width: 31.5147192,
    height: 5.15622862
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.2375302,22.1666392 C72.3777291,20.5844179 71.4279166,19.0533995 70.4472007,17.5477885 C68.1897511,14.0773168 65.766799,10.698729 63.1478708,7.49869663 C62.1271048,6.2483241 61.0813581,5.01322515 59.9201179,3.89578122 C59.1560599,3.16044338 58.3081043,2.55716137 57.4000614,2.06249145 C57.779141,2.34408286 58.1434376,2.65018472 58.4902048,2.98392448 C59.6514928,4.10136841 60.6972394,5.3364916 61.7179577,6.58686413 C64.3368858,9.78684805 66.7598618,13.1654843 69.0172876,16.6359318 C69.9980273,18.1415427 70.9478398,19.6725611 71.807641,21.2547824 C72.3305143,22.2245333 72.9338462,23.2704096 73.1602718,24.3680221 C73.88705,27.876508 60.518769,40.8745638 56.1743159,44.7417848 C56.0243128,44.5758604 55.8142464,44.4466654 55.6161926,44.3913169 C55.354756,44.3181976 54.9516988,44.3405504 54.7227895,44.5099659 C54.6761479,44.5444405 54.5727148,44.5861883 54.5152068,44.629318 C54.493713,44.6354516 54.4723863,44.6422399 54.4507014,44.6476462 C54.2719205,44.6935882 54.088793,44.7213716 53.9085075,44.7605495 C53.495205,44.8503727 53.2204183,45.186658 53.1157911,45.5738068 C53.0885655,45.6330586 53.0654955,45.694759 53.047584,45.7595626 C53.0337801,45.8638108 53.0199524,45.9681075 53.0061486,46.0724285 C53.0007513,46.2178426 53.0272842,46.3544078 53.0851982,46.4823179 C53.1451421,46.7999598 53.28607,47.549359 53.4788219,48.587938 L51.8524552,48.587938 L26.0250584,48.3363604 C26.1401221,48.616982 26.2197209,48.9108408 26.2256437,49.2362164 L53.2823444,49.4997947 L54.9087112,49.4997947 C54.7159592,48.4611915 54.5750313,47.7118166 54.5150874,47.3941504 C54.4571973,47.2662645 54.4306883,47.1296994 54.4360617,46.984261 C54.4498656,46.8799643 54.4636933,46.7756676 54.4774971,46.6713951 C54.4953847,46.6066157 54.5184548,46.5449153 54.5457042,46.485712 C54.6502836,46.0985148 54.9250942,45.7622294 55.3384445,45.6724062 C55.5187062,45.6332283 55.7018097,45.6054449 55.8806146,45.5595272 C55.9022994,45.5540966 55.9235783,45.5473084 55.9451199,45.5411747 C56.0026279,45.498045 56.106061,45.4562973 56.1527026,45.4217984 C56.3816119,45.2524314 56.7846691,45.2300786 57.0460819,45.3031736 C57.2441356,45.3585464 57.4542259,45.4877414 57.604229,45.6536416 C61.9486821,41.7864448 75.3169631,28.7883648 74.5902088,25.2798304 C74.3637354,24.1822663 73.7604274,23.13639 73.2375302,22.1666392",
    id: "Fill-7",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.327683222,
    mask: "url(#mask-14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2192819,44.636497 C51.2183088,46.1439848 51.9573775,46.1702169 53.4364881,44.7151932 L63.9628475,26.3934452 L53.9612022,14.4695817 C53.8586244,14.3474335 53.6764573,14.3314629 53.5542497,14.4339697 C53.4895111,14.4882719 53.4518,14.5682013 53.4510537,14.6526954 C53.3068883,30.974537 52.5629644,40.9691375 51.2192819,44.636497 Z",
    id: "Fill-5",
    stroke: "none",
    fillOpacity: 0.4,
    fill: "#000000",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.439964658,
    mask: "url(#mask-14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3789619,28.0736507 C20.4387012,29.0229876 24.2964348,26.3001229 28.9521627,19.9050566 C29.8536044,27.837055 29.2395386,34.8684589 27.1099653,40.9992685 C26.8602954,42.3826773 26.0242446,43.2224443 24.601813,43.5185695 L26.0250584,29.8187756 L15.9252382,32.0332717 L4.87969845,13.8690465 L6.47846684,13.0863471 C10.6857242,22.1285459 14.3192226,27.1243138 17.3789619,28.0736507 Z",
    id: "Path-17",
    stroke: "none",
    fillOpacity: 0.4,
    fill: "#000000",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.4,
    mask: "url(#mask-14)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1955229,28.5735726 C48.7476255,26.2891597 48.4608735,22.5180715 48.4443482,22.4811568 L41.0707953,25.8251372 L41.0707953,31.6779838 C41.2278336,32.1362953 41.8410423,33.5575601 44.1949821,32.7940986 C46.5489218,32.0306372 49.999849,30.9094085 49.5726323,29.9579121 C49.5323339,29.8685536 49.4925669,29.7615033 49.4548294,29.6404064 C49.3634089,29.3546148 49.276603,28.9887724 49.1955229,28.5735726 Z",
    id: "Fill-11",
    fill: "url(#linearGradient-17)",
    mask: "url(#mask-11)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    mask: "url(#mask-11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.827529, 28.302951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.763813122,0.727844431 C0.770368672,0.570891009 0.76410118,0.700176338 0.0253756718,1.37365835 C-0.184249232,2.83276027 0.931247626,4.08609777 2.39698387,4.60846804 C2.58552679,4.16038101 2.67357422,3.36190341 2.46163257,2.88297075 C1.50757308,2.21279923 0.706161443,2.10814491 0.763813122,0.727844431 Z",
    id: "Fill-21-Copy",
    fill: "url(#linearGradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66206882,4.66945208 C7.44735831,4.227971 9.46421603,3.00171553 9.71264197,0.990685664 C9.49060735,0.678441781 9.76929473,0.246330766 9.32899804,0 C9.14898187,0.152386038 6.8612491,2.72056488 4.58065592,2.78897617 C4.50949463,3.34898217 4.20329892,3.97580747 3.66206882,4.66945208 Z",
    id: "Fill-17-Copy",
    fill: "url(#linearGradient-19)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M41.0707953,25.8306057 L41.0707953,28.5132869 C41.69556,28.6878704 42.3693754,28.7067061 43.0143473,28.6126004 C44.2037121,28.4390877 45.5020516,27.9855699 46.4526822,27.2333815 C47.2023469,26.640153 48.4896183,24.270998 48.5994591,24.0518805 C48.4870443,22.9420807 48.4171391,22.4552852 48.4127608,22.4817866 L41.0707953,25.8306057 Z",
    id: "Fill-13",
    fill: "#000000",
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.218703497,
    mask: "url(#mask-11)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0385282,70.5555013 C53.6746295,70.7866864 50.7370347,71.1440072 50.1075227,72.0477567 C49.4780347,72.9515302 49.9396608,72.8044277 50.7370347,72.3630243 C51.5343846,71.9216688 52.4366332,72.0057035 52.4366332,72.0057035 C52.4366332,72.0057035 50.7370347,72.9725688 50.632112,73.9604009 C50.5742443,74.5052001 51.0844085,75.0947603 51.553618,75.5139989 C51.9520896,75.8699779 52.5084954,75.9874874 53.019784,75.8332442 C53.7537162,75.6118596 54.8648532,75.3634219 55.5001544,75.641836 C55.5102256,75.646245 55.520249,75.65063 55.5302245,75.6549432 C56.3752274,76.022975 57.3548882,75.88251 58.0651614,75.2945073 L61.606193,72.3630243 L57.1368137,68.474716 C57.1368137,68.474716 56.4024269,70.3243163 55.0385282,70.5555013",
    id: "Fill-15",
    fill: "url(#linearGradient-20)",
    mask: "url(#mask-11)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1930623,36.1017241 C48.7122455,33.0313399 50.09605,30.4906328 50.344476,28.479603 C50.1224414,28.1673591 49.4511254,27.4712179 49.0108287,27.2248871 C48.8308126,27.3772731 46.6819716,31.0160942 44.4013784,31.0845055 C44.5579949,31.4553131 45.1552228,33.1277193 46.1930623,36.1017241 Z",
    id: "Fill-17",
    fill: "#FFFFFF",
    mask: "url(#mask-11)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2262424,28.7075837 C49.3989282,28.7139837 49.0525196,28.6968837 49.2262424,28.7075837",
    id: "Fill-19",
    fill: "#FFFFFF",
    mask: "url(#mask-11)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0744314,29.0095515 C41.0743004,28.851444 41.0774593,27.7236792 41.0721852,27.5437022 C40.7346575,27.9200296 40.2326597,28.4087216 39.4939342,29.0822036 C39.2843093,30.5413055 39.4492592,34.3662134 40.5756642,35.903263 C40.8812411,34.4808018 41.5832639,31.6655891 42.2891614,31.1859222 C41.3351019,30.5157507 41.0753125,30.0733635 41.0744314,29.0095515 Z",
    id: "Fill-21",
    fill: "#FFFFFF",
    mask: "url(#mask-11)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0457685,70.4677309 L59.8167247,74.6861181 C60.0557926,74.8974974 60.4209522,74.8750513 60.6323314,74.6359833 C60.6342616,74.6338004 60.6361751,74.6316029 60.638072,74.629391 L61.8416032,73.2259846 C62.048719,72.9844723 62.021624,72.6209666 61.780992,72.4128285 L57.3261731,68.5595692 C57.12781,68.3879921 56.8387672,68.3715369 56.6222129,68.5194926 L55.1025444,69.5577711 C54.8390554,69.7377939 54.7713927,70.0973312 54.9514155,70.3608203 C54.9783318,70.4002161 55.0100241,70.4361263 55.0457685,70.4677309 Z",
    id: "Fill-23",
    fill: "#FFFFFF",
    mask: "url(#mask-11)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7683618,97.5858584 C59.7683618,95.2514847 57.5885197,83.2852355 56.6457436,78.2164588 C56.6015618,77.9783558 56.5600846,77.7554736 56.5218144,77.5496784 L27.8549453,77.5496784 C27.8818469,77.6793214 27.8977868,77.8131331 27.9004914,77.9529798 C27.9055174,78.442516 27.9004914,78.9325854 27.9004914,79.4170804 C27.9055174,81.1059051 27.9055174,82.7947541 27.9109744,84.4835546 C27.9160005,89.6571073 27.925574,94.8306358 27.9410591,99.9990988 C27.9661178,109.382256 28.0823164,118.974407 28.4545826,128.433716 C28.6464359,133.270449 28.903413,138.102068 29.2506206,142.929058 C29.4224174,145.347412 29.6187941,147.760677 29.8402535,150.173941 C29.9714586,151.638042 29.6488789,155.776147 30.7574923,156.812055 C31.0131291,157.048777 31.2204436,157.184455 31.3730694,157.262885 L31.3744337,157.263346 L31.6742762,157.368097 L40.2251506,157.368097 C40.2247198,157.365771 40.2242411,157.364389 40.2242411,157.363032 C40.1991825,157.235207 41.4841639,156.770974 41.2927893,156.005961 C41.1059382,155.24044 40.0328665,124.372223 40.6224995,114.591364 C41.1870737,105.11681 42.703495,96.642196 42.7991823,96.1217336 C42.6328663,97.2033037 44.2705123,100.030025 44.673318,101.142085 C45.383673,103.101272 46.0739954,105.065573 46.7442852,107.040514 C48.0693079,110.96914 49.293689,114.933249 50.3462494,118.943505 C51.4047693,122.96394 52.2864663,127.025433 52.9366997,131.132636 C53.4857409,134.59194 53.5153709,138.377981 54.7046411,141.694262 C55.712565,144.500213 58.8010057,156.490432 59.4913281,157.036319 C59.5710516,157.098632 59.5833775,157.212109 59.542355,157.368097 L68.94398,157.368097 C69.1348999,157.257335 69.5600119,156.952338 69.729535,156.368157 C69.9509704,155.60266 66.232329,139.250071 65.3105429,133.979644 C64.3832998,128.709216 59.7683618,100.560667 59.7683618,97.5858584",
    id: "Fill-27",
    fill: "#646464",
    mask: "url(#mask-11)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.3291139,157.036126 C60.640717,156.489945 57.5608906,144.492736 56.5558019,141.685126 C55.369825,138.366936 55.3403014,134.578688 54.7927677,131.117368 C54.1443719,127.007795 53.2651103,122.943887 52.2095667,118.921132 C51.1599182,114.908538 49.9389761,110.94207 48.6176253,107.011179 C47.949205,105.035111 47.260832,103.069665 46.5524344,101.109312 C46.1507522,99.9966033 44.3512014,97.7136876 44.5170773,96.6314386 C44.4817541,96.8241369 43.2039846,94.2523192 42.9006822,96.2709961 C42.9006822,97.1543627 44.6708288,100.743898 44.8027419,101.109312 C45.5111395,103.069665 46.1995364,105.035111 46.8679567,107.011179 C48.1893074,110.94207 49.4102257,114.908538 50.4598742,118.921132 C51.5154178,122.943887 52.3946556,127.007795 53.0430752,131.117368 C53.5906089,134.578688 53.6201563,138.366936 54.8060855,141.685126 C55.8112219,144.492736 58.8910483,156.489945 59.5794214,157.036126 C59.6589225,157.098451 59.6712379,157.212042 59.6303059,157.368097 L61.3800223,157.368097 C61.4209304,157.212042 61.4086389,157.098451 61.3291139,157.036126",
    id: "Fill-29",
    fill: "#000000",
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.437569754,
    mask: "url(#mask-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2513191,157.262885 C33.1009997,157.184455 32.8967946,157.048777 32.6450209,156.812055 C31.5531609,155.776148 31.8708893,151.638068 31.7416435,150.173944 C31.5235308,147.76068 31.3301452,145.347416 31.1609446,142.929038 C30.8189605,138.102074 30.5658668,133.270456 30.3769364,128.433725 C30.0102723,118.974419 29.8958533,109.38227 29.8711733,99.9991162 C29.8558985,94.8306548 29.8464933,89.6571279 29.8415431,84.483601 C29.8361687,82.7947525 29.8361687,81.1059283 29.8312185,79.417104 C29.8312185,78.9326335 29.8361687,78.44254 29.8312185,77.9529797 C29.8285313,77.813133 29.8128323,77.6793456 29.7863372,77.5496784 L28.0582661,77.5496784 C28.0847376,77.6793456 28.1004602,77.813133 28.103171,77.9529797 C28.1080975,78.44254 28.103171,78.9326335 28.103171,79.417104 C28.1080975,81.1059283 28.1080975,82.7947525 28.113472,84.483601 C28.1184221,89.6571279 28.1278274,94.8306548 28.1431021,99.9991162 C28.1677821,109.38227 28.2822011,118.974419 28.6488652,128.433725 C28.8378192,133.270456 29.090913,138.102074 29.4328735,142.929038 C29.6020741,145.347416 29.7954832,147.76068 30.0135959,150.173944 C30.1428182,151.638068 29.8250898,155.776148 30.9169733,156.812055 C31.1687234,157.048777 31.372905,157.184455 31.5232243,157.262885 L31.5245915,157.26337 L31.8198793,157.368097 L33.5479269,157.368097 L33.2526862,157.26337 L33.2513191,157.262885 Z",
    id: "Fill-31",
    fill: "#000000",
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.437569754,
    mask: "url(#mask-11)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7311164,11.9624504 L37.0056944,12.4855236 C37.0056944,12.4855236 36.9584183,14.5301897 37.4309148,19.570584 C37.5640185,20.9906583 37.7613426,22.4179649 38.2235523,23.7719808 C38.6027704,24.8830247 39.144847,26.0153543 40.1666546,26.6632637 C41.0062317,27.1956736 42.0562078,27.3113907 43.0384063,27.1688487 C44.2267016,26.9963857 45.5238737,26.5455873 46.4736494,25.7979493 C47.2226401,25.2083097 47.7963463,24.4291785 48.2680256,23.6052989 C48.5070979,23.1877594 48.7159827,22.7556102 48.9244589,22.3221548 C49.0366285,22.0889791 49.4484375,20.5419401 49.4035409,20.274949 C49.4034447,20.2743926 47.7311164,11.9624504 47.7311164,11.9624504",
    id: "Fill-37",
    fill: "url(#linearGradient-21)",
    mask: "url(#mask-11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-41",
    mask: "url(#mask-11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.597738, 7.012471)"
  }, _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-23",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-22"
  }))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "none",
    fill: "#5A5A5A",
    fillRule: "evenodd",
    xlinkHref: "#path-22"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.9745829,9.44425206 C11.9722569,9.40973386 11.9699546,9.37514294 11.9678422,9.34069746 C11.9121604,8.4322434 11.82109,7.52679514 11.6543294,6.63264286 C11.5606482,6.13011701 11.4038325,5.6051204 10.9842727,5.34131312 C10.4200968,4.98662892 9.53077812,5.13485841 8.91236827,5.2564478 C8.18646358,5.3991505 7.48740293,5.66230329 6.81511512,5.97204596 C6.07273849,6.31410096 5.34571826,6.71411454 4.55117257,6.89666831 C3.63769187,7.10658938 2.6829601,7.01379748 1.78540544,6.7693582 C1.18797714,6.60663301 0.317147851,6.28680637 0.392149774,5.49826912 C0.436510089,5.03178861 0.531757785,4.57093186 0.672647474,4.12498289 C0.555089079,4.36593157 0.448519891,4.61584915 0.356523861,4.87657791 C0.175878405,5.38855748 0.0560652063,5.92288661 0.00453698616,6.46468176 C-0.0704412024,7.25319477 0.800364357,7.57306989 1.39781639,7.73579508 C2.29537105,7.98023436 3.25007908,8.07302626 4.16355978,7.86308094 C4.95812921,7.68050294 5.68514943,7.2805136 6.42752607,6.9384586 C7.09981388,6.62871593 7.79887453,6.36558738 8.52477922,6.22286044 C9.14318906,6.10127105 10.0324603,5.95301732 10.5966836,6.30772576 C11.0162434,6.57153304 11.1730592,7.09652965 11.2667404,7.5990555 C11.3965459,8.29511597 11.4801636,8.99801221 11.5372457,9.70384153 C11.5534803,9.90474521 11.5679348,10.1058186 11.5802531,10.3071101 C11.6273667,11.0758673 11.7258423,11.8655196 11.5933547,12.6320951 C11.5401651,12.9398985 12.3251694,12.7441338 13.1828022,12.4454932 C13.2420916,12.4248405 13.3001469,12.4020061 13.3576088,12.3780567 C13.3749115,12.370833 13.3919293,12.3631973 13.4090421,12.3557071 C13.4506492,12.3374784 13.4917104,12.3184497 13.5322731,12.2985242 C13.5493147,12.2901613 13.566475,12.2818954 13.5833741,12.2732416 C13.6350685,12.2467227 13.6860271,12.219113 13.7359413,12.1899034 C13.7414003,12.1866794 13.7469068,12.1834555 13.7523658,12.1802073 C13.8014493,12.1510462 13.8494648,12.1203095 13.8967208,12.0886516 C13.9142845,12.0768466 13.9314922,12.0646537 13.9487949,12.0525578 C13.9820236,12.0292871 14.0147301,12.0054831 14.0469382,11.9810246 C14.0647631,11.9674985 14.0826354,11.9540937 14.1001516,11.940204 C14.1377238,11.9104126 14.1745127,11.8797001 14.2106608,11.8483089 C14.2279397,11.8333042 14.2450288,11.818057 14.2619991,11.8026644 C14.2959873,11.7718308 14.3294534,11.7403911 14.3620413,11.708103 C14.3805069,11.6898743 14.3984029,11.6711608 14.4163939,11.6524957 C14.4399863,11.6279645 14.4631752,11.603094 14.4859843,11.5778841 C14.5042601,11.5576676 14.5224884,11.5374997 14.540242,11.5168227 C14.5643566,11.488704 14.5876641,11.4599065 14.6108055,11.4309878 C14.6363916,11.3990148 14.6613369,11.366557 14.6857125,11.3336387 C14.7065279,11.3055199 14.7272959,11.2773769 14.7471619,11.2485795 C14.7642984,11.2238301 14.7807229,11.1986444 14.7971711,11.173386 C14.8131446,11.1488306 14.8288333,11.1240328 14.8441897,11.099041 C14.8602581,11.0728372 14.8762554,11.0466334 14.8915643,11.0199933 C14.9072768,10.9926745 14.9221347,10.9648466 14.9370639,10.9370672 C15.0765058,10.6775747 15.18298,10.3985688 15.2490577,10.1056489 C15.1454079,10.2783369 15.0256184,10.4405288 14.8922764,10.590746 C14.6058212,9.81243811 13.8158564,9.25285058 12.885073,9.25285058 C12.5591469,9.25285058 12.2505472,9.32169306 11.9745829,9.44425206 Z",
    id: "Fill-41",
    stroke: "none",
    fillOpacity: 0.4,
    fill: "#000000",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "soft-light"
    },
    filter: "url(#filter-24)",
    mask: "url(#mask-23)"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3052865,16.7061807 C48.1262472,16.7061807 47.1704184,17.583408 47.1704184,18.6655236 C47.1704184,19.7476872 48.1262472,20.6249145 49.3052865,20.6249145 C50.4843496,20.6249145 51.4401545,19.7476872 51.4401545,18.6655236 C51.4401545,17.583408 50.4843496,16.7061807 49.3052865,16.7061807",
    id: "Fill-43",
    fill: "url(#linearGradient-25)",
    mask: "url(#mask-11)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92042559,39.3467926 L7.44871493,40.9580252 C7.59785004,41.4128732 8.08747511,41.6607025 8.54232313,41.5115674 C8.60666629,41.4904706 8.66831549,41.4619062 8.72600939,41.4264587 L12.8280225,38.9061514 C13.2261957,38.6615108 13.3587224,38.1452447 13.1276159,37.7390665 L12.2874543,36.2624514 C12.0507348,35.8464083 11.5215662,35.7010377 11.105523,35.9377571 C11.0943501,35.9441143 11.08332,35.9507192 11.0724409,35.957567 L7.28230017,38.3432567 C6.94571339,38.55512 6.79651395,38.9688738 6.92042559,39.3467926 Z",
    id: "Fill-25",
    fill: "#FFFFFF",
    mask: "url(#mask-11)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3766958,1.23749487 L55.0148137,1.23749487 C58.2059681,1.23749487 60.7929099,3.82443667 60.7929099,7.0155911 L60.7929099,59.1201894 L60.7929099,59.1201894 C55.1772326,51.9412153 50.1160545,43.2850622 45.6093755,33.1517302 C41.1026966,23.0183982 37.6918033,12.3803198 35.3766958,1.23749487 Z",
    id: "Rectangle",
    fillOpacity: 0.2,
    fill: "url(#linearGradient-26)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "shadow-large-copy-13",
    transform: "translate(0.000000, 83.000000)",
    fill: "url(#radialGradient-27)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow-copy",
    cx: 45.5,
    cy: 3.5,
    rx: 45.5,
    ry: 3.5
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "shadow-large-copy-17",
    transform: "translate(50.000000, 168.216300)",
    fill: "url(#radialGradient-28)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow-copy",
    cx: 89.5,
    cy: 6.5,
    rx: 89.5,
    ry: 6.5
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "handshake",
    transform: "translate(65.786960, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-31",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-29)",
    fillRule: "evenodd",
    xlinkHref: "#path-30"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-32)",
    xlinkHref: "#path-30"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "url(#linearGradient-33)",
    cx: 71.1539059,
    cy: 71.1539059,
    r: 66.8846715
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(21.346172, 22.769250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1440786,2.27834807 C40.733263,2.27834807 33.1048528,9.90604678 33.1048528,19.3175739 C33.1048528,28.7283895 40.733263,36.3567998 50.1440786,36.3567998 C59.5548942,36.3567998 67.1833045,28.7283895 67.1833045,19.3175739 C67.1833045,9.90604678 59.5548942,2.27834807 50.1440786,2.27834807 M50.1440786,38.6351478 C39.5442813,38.6351478 30.8265047,30.0162752 30.8265047,19.3175739 C30.8265047,8.61816108 39.4453774,0 50.1440786,0 C60.743876,0 69.3627486,8.71777655 69.3627486,19.3175739 C69.3627486,29.9173713 60.743876,38.6351478 50.1440786,38.6351478",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6581005,27.4406461 L41.6245369,21.1008331 C41.1293057,20.7045058 41.1293057,20.0107553 41.5256329,19.5155241 C41.9219602,19.0202929 42.6149992,19.0202929 43.1102304,19.4166201 L48.4602926,24.1718357 L57.7722043,12.7793838 C58.1685315,12.2841526 58.8615706,12.1845372 59.3568018,12.5808644 C59.8520329,12.9771917 59.9516484,13.6709422 59.5553212,14.1661734 L48.6581005,27.4406461 Z",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0449613,55.4758543 C51.5306548,55.4758543 53.0170599,56.4663166 54.4038495,58.2494335 C54.7012729,58.7446647 61.8337404,69.0477503 71.5419793,63.3020724 L67.183091,52.9989868 L54.6016574,50.0275997 C52.4222132,49.6312724 51.1343276,49.432753 49.648634,50.1265036 L44.5967067,52.4048517 C43.0113977,53.0986023 41.8224159,54.4853919 41.3271847,56.1696049 L40.039299,60.726301 C39.9403951,61.1226282 40.1382029,61.6178594 40.5345302,61.8156673 C41.4260886,62.31161 42.3176471,62.4105139 43.1103016,62.1130906 C44.2003794,61.7167634 45.0919379,60.5284931 45.8845924,58.7446647 L45.8845924,58.6457608 C46.0824002,58.349049 47.4691899,55.6736621 49.9460573,55.4758543 C49.8471534,55.4758543 49.9460573,55.4758543 50.0449613,55.4758543 M65.6973975,67.3635373 C57.8711794,67.3635373 52.6207326,59.7358386 52.5218287,59.6362232 C51.9269821,58.7446647 50.9365197,57.7542023 49.9460573,57.7542023 C48.955595,57.8531063 47.964421,59.140992 47.7666132,59.6362232 C46.7761508,62.0141867 45.3886496,63.5987842 43.8040522,64.1936308 C42.5161665,64.688862 40.9308574,64.5899581 39.4451639,63.8962075 C38.0583743,63.2031685 37.3646237,61.6178594 37.8598549,60.1321659 L39.1477406,55.5747582 C39.8414911,53.2964101 41.5257041,51.3154854 43.7051482,50.4232154 L48.7570756,48.2444828 C50.9365197,47.2533089 52.918156,47.5507322 55.0968886,48.0459634 L68.7684,51.3154854 L74.3155586,64.1936308 L73.522904,64.688862 C70.7493248,66.5708828 68.0746495,67.3635373 65.6973975,67.3635373",
    id: "Fill-5",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3102521,67.2644911 L67.4801586,71.7222833 L74.1173949,69.6417431 L72.433182,65.5802781 C69.5606988,67.462299 66.4896962,67.5619144 64.3102521,67.2644911 L64.3102521,67.2644911 Z M66.5886001,74.2980547 L58.4656702,62.9056028 L62.1308079,64.3912964 C62.3286158,64.4909118 67.8764858,66.670356 72.2353741,62.9056028 L73.4243559,61.9151404 L77.288013,70.9296288 L66.5886001,74.2980547 Z",
    id: "Fill-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 33.366946)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-35",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42860407,44.7946232 L0.71082752,41.3272933 C0.116692406,41.1294855 -0.180730921,40.4357349 0.116692406,39.8415998 C0.314500264,39.2467531 1.00825085,38.9500413 1.60238596,39.2467531 L8.14071837,41.9214284 L21.0188638,10.4194597 L0.71082752,2.19691432 C0.116692406,1.99910646 -0.180730921,1.30535588 0.116692406,0.711220763 C0.314500264,0.11637411 1.00825085,-0.180337677 1.60238596,0.11637411 L23.9909625,9.23047792 L9.42860407,44.7946232 Z",
    id: "Fill-9",
    fill: "#FFFFFF",
    mask: "url(#mask-35)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.0994752,71.7223545 L12.4996778,67.5619856 C11.9055427,67.3634662 11.6081194,66.6704271 11.9055427,66.0755805 C12.1033505,65.4814454 12.7971011,65.184022 13.3912362,65.4814454 L21.9104934,68.8491597 L29.7367115,50.6216637 L21.018935,46.956526 C20.4247998,46.7580066 20.2262804,46.0649675 20.4247998,45.4701209 C20.6226077,44.8759858 21.3163583,44.6774664 21.9104934,44.8759858 L32.7088102,49.4326819 L23.0994752,71.7223545 Z",
    id: "Fill-12",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(75.108355, 35.489491)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-37",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5623584,44.7524048 L0,9.18825953 L22.3885765,0.0741557263 C22.9827116,-0.123652132 23.5775583,0.0741557263 23.87427,0.66900238 C24.0727894,1.26313749 23.87427,1.85727261 23.2801349,2.15469593 L2.97209865,10.3772413 L15.8502441,41.8792101 L22.4874804,39.2045347 C23.0816155,39.0067269 23.6764622,39.3041502 23.973174,39.7993814 C24.1716934,40.3935165 23.87427,40.9876516 23.3790389,41.2850749 L14.5623584,44.7524048 Z",
    id: "Fill-14",
    fill: "#FFFFFF",
    mask: "url(#mask-37)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.9998427,73.8027524 L66.3905077,51.5130798 L77.2877284,46.9563837 C77.8818635,46.7578643 78.4767101,46.9563837 78.7734219,47.5505188 C78.9719413,48.1453654 78.7734219,48.7395005 78.1792868,49.0369239 L69.3626063,52.7020616 L77.1888244,70.9295576 L85.7080816,67.5618433 C86.3022167,67.3633239 86.8970633,67.6607472 87.1937751,68.1559784 C87.3922945,68.7501135 87.0948712,69.3449601 86.59964,69.6423835 L75.9998427,73.8027524 Z",
    id: "Fill-17",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9943227,80.4400598 C64.9049564,80.4400598 63.8148786,79.9448287 63.0222241,79.1521742 L52.818754,68.2549535 C52.4224267,67.7597223 52.4224267,67.0666832 52.818754,66.670356 C53.3139851,66.2740287 54.0077357,66.2740287 54.404063,66.670356 L64.6075331,77.4679612 C65.1027643,77.9631924 65.6968994,78.1617118 66.39065,78.0628079 C67.083689,77.9631924 67.5796317,77.4679612 67.7774396,76.8738261 C67.975959,76.3785949 67.8763435,75.7837482 67.4800163,75.3881325 L60.0501254,66.0755093 C59.6545097,65.5802781 59.7534136,64.8872391 60.2486448,64.4909118 C60.743876,64.0945846 61.4376266,64.1934885 61.8339538,64.6887197 L69.2631332,74.0006314 C70.0557877,74.9918053 70.353211,76.3785949 69.8579798,77.5668651 C69.3627486,78.9543663 68.2726708,79.9448287 66.7869772,80.242252 C66.5884578,80.3411559 66.291746,80.4400598 65.9943227,80.4400598",
    id: "Fill-19",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9420396,84.105411 C59.4563461,84.105411 57.969941,83.5112759 56.8805747,82.4211981 L48.2617021,73.4067097 C47.8653748,72.9114785 47.8653748,72.2177279 48.2617021,71.8214007 C48.6580293,71.4250734 49.4506838,71.4250734 49.8470111,71.8214007 L58.4651722,80.8366006 C59.2578267,81.728159 60.4468084,82.0248708 61.6357902,81.8270629 C62.8240604,81.5296396 63.616715,80.7369851 64.0130422,79.6476188 L64.0130422,79.5487149 C64.2108501,78.9538682 64.8056967,78.6571564 65.3998318,78.8549643 C65.993967,79.0534837 66.2913903,79.6476188 66.0935824,80.2417539 L66.0935824,80.4402733 C65.4987358,82.3222941 64.0130422,83.7090837 62.1310214,84.105411 C61.7346941,84.0065071 61.3383669,84.105411 60.9420396,84.105411",
    id: "Fill-21",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3944542,87.3745061 L55.0970309,87.3745061 C53.7102413,87.2756021 52.3234516,86.5818515 51.2340853,85.4924852 L44.1009063,77.5673632 C43.704579,77.072132 43.704579,76.3783814 44.2005217,75.9820542 C44.6957529,75.5857269 45.388792,75.5857269 45.7851192,76.0809581 L52.9175867,84.0060802 C53.5124334,84.6998307 54.4039918,85.096158 55.1966463,85.1950619 C56.4838205,85.2939658 57.6728023,84.5013113 58.6632646,82.9167139 C58.960688,82.4214827 59.6544386,82.2229633 60.1496697,82.5203866 C60.6449009,82.8178099 60.8427088,83.510849 60.545997,84.0060802 C58.861784,86.7803709 56.8801478,87.3745061 55.3944542,87.3745061",
    id: "Fill-23",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3889343,51.9095494 L45.0915109,51.9095494 C38.9495058,50.5227597 31.3218071,51.1168948 31.2229031,51.1168948 C30.6280565,51.2157988 30.0339214,50.7205676 30.0339214,50.1264325 C29.9350174,49.5322974 30.4302486,48.9374507 31.0243837,48.9374507 C31.3218071,48.9374507 39.0491212,48.2444117 45.5867421,49.7301052 C46.1815888,49.8290091 46.577916,50.4238558 46.3793966,51.1168948 C46.3793966,51.612126 45.8841654,51.9095494 45.3889343,51.9095494",
    id: "Fill-25",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.945915,89.1576941 C48.9554526,89.1576941 47.8653748,88.7613668 47.1723358,88.0683278 L43.8039099,84.8977097 C33.3030164,74.4964318 23.4958736,67.660676 23.3969696,67.660676 C22.9010269,67.2643488 22.802123,66.5713097 23.0995463,66.0760786 C23.4958736,65.5801358 24.1889126,65.4812319 24.6848553,65.7786552 C24.7837593,65.8775592 34.6898061,72.8122188 45.3892189,83.2134968 L48.7569332,86.3841148 C49.2521644,86.879346 49.945915,86.97825 50.6396656,86.7804421 C50.9363774,86.6808266 51.630128,86.3841148 51.8279358,85.4925564 C51.9275513,84.8977097 52.4227825,84.4024786 53.1158215,84.5013825 C53.7106682,84.600998 54.2058994,85.0962291 54.1062839,85.6903643 L54.1062839,85.7892682 C53.908476,87.2756733 52.9180137,88.3650396 51.4316086,88.8602708 C50.8374735,89.0587902 50.3422423,89.1576941 49.945915,89.1576941",
    id: "Fill-27",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5160953,88.9596016 C41.3271135,88.9596016 40.0392278,88.4643704 39.1476694,87.6717159 L30.0342771,79.548786 C28.646776,78.2609003 28.0526409,76.378168 28.4489681,74.4961472 L29.2416226,71.2273367 C29.4394305,70.6324901 30.0342771,70.2361628 30.6284123,70.4346822 C31.2225474,70.6324901 31.6188746,71.2273367 31.4210668,71.8214718 L30.6284123,75.0902823 C30.3309889,76.1803601 30.7273162,77.2697264 31.5199707,77.963477 L40.6340745,86.0864069 C41.5256329,86.8790614 42.7139032,87.0775808 43.803981,86.5823496 L46.5775603,85.2944639 C47.1724069,84.9970406 47.766542,85.2944639 48.0639654,85.888599 C48.3606771,86.4827342 48.0639654,87.0775808 47.4691187,87.3742926 L44.6955395,88.6621783 C44.0017889,88.8606977 43.3087498,88.9596016 42.5160953,88.9596016",
    id: "Fill-29",
    fill: "#FFFFFF"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(195.000000, 88.216300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-94",
    transform: "translate(3.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-38)",
    fillRule: "evenodd",
    xlinkHref: "#path-39"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-40)",
    xlinkHref: "#path-39"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.02364973,4.98553081 L69.0846288,4.98553081 C70.5198787,4.98553081 71.6833786,6.14903073 71.6833786,7.58428062 L71.6833786,43.63787 C71.6833786,45.0731199 70.5198787,46.2366199 69.0846288,46.2366199 L7.02364973,46.2366199 C5.58839984,46.2366199 4.42489991,45.0731199 4.42489991,43.63787 L4.42489991,7.58428062 C4.42489991,6.14903073 5.58839984,4.98553081 7.02364973,4.98553081 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-41)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-90",
    transform: "translate(43.265689, 14.531510)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-42"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-43)",
    xlinkHref: "#path-42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-44"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-45)",
    xlinkHref: "#path-44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-15"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-46"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-47)",
    xlinkHref: "#path-46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-48"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-49)",
    xlinkHref: "#path-48"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-134",
    transform: "translate(9.833111, 10.568371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-50"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-51)",
    xlinkHref: "#path-50"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 1.88999999,
    x: 0,
    y: 0,
    width: 27.7293746,
    height: 30.9124854,
    rx: 6.61499996
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-53",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 59.000000)",
    fill: "url(#radialGradient-54)",
    id: "shadow-large-copy-14"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow-copy",
    cx: 40.5,
    cy: 3,
    rx: 40.5,
    ry: 3
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillarCultureIcon);
export default __webpack_public_path__ + "static/media/pillar-culture-icon.5bfe1fbb83329c6a98a53d61d9653b5c.svg";
export { ForwardRef as ReactComponent };